import React, { useCallback, useEffect, useState } from 'react';
// components
import PageContent from 'components/PageContent/PageContent';
// API
import { CardFilter, CardResult, CardType, fetchCards, fetchCardTypes } from 'api/card';
// contexts
import { CardsContext, defaultCardResult } from 'contexts/cardResult';
import { CardTypesContext } from 'contexts/cardTypes';
import { CardFilterContext, defaultCardFilter } from 'contexts/cardFilter';

const Search = () => {
  const [loading, setLoading] = useState(true);
  const [cardResult, setCardResult] = useState<CardResult>(defaultCardResult);
  const [cardFilter, setCardFilter] = useState<CardFilter>(defaultCardFilter);
  const [supertypeList, setSupertypeList] = useState<CardType[]>([]);
  const [typeList, setTypeList] = useState<CardType[]>([]);
  const [subtypeList, setSubtypeList] = useState<CardType[]>([]);

  const loadCards = useCallback(
    async (filter: CardFilter) => {
      setLoading(true);

      const newCardResult: CardResult = await fetchCards(filter);
      setCardResult(newCardResult);

      setLoading(false);
    },
    [],
  );

  const loadCardTypes = async () => {
    setLoading(true);

    const supertypesRes: CardType[] = await fetchCardTypes('supertype');
    const typesRes: CardType[] = await fetchCardTypes('type');
    const subtypesRes: CardType[] = await fetchCardTypes('subtype');
    setSupertypeList(supertypesRes);
    setTypeList(typesRes);
    setSubtypeList(subtypesRes);

    setLoading(false);
  };

  useEffect(
    () => {
      loadCardTypes();
      loadCards(cardFilter);
    }, []
  );

  return (
    <>
      <CardFilterContext.Provider value={{ cardFilter, setCardFilter, loadCards }}>
        <CardTypesContext.Provider value={{ supertypeList: supertypeList, typeList: typeList, subtypeList: subtypeList }}>
          <CardsContext.Provider value={{ cardResult }}>
            <PageContent loading={loading} />
          </CardsContext.Provider>
        </CardTypesContext.Provider>
      </CardFilterContext.Provider>
    </>
  );
};

export default Search;
